import { render, staticRenderFns } from "./DataInfo.vue?vue&type=template&id=4ef0bbe2&scoped=true&"
import script from "./DataInfo.vue?vue&type=script&lang=js&"
export * from "./DataInfo.vue?vue&type=script&lang=js&"
import style0 from "./DataInfo.vue?vue&type=style&index=0&id=4ef0bbe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef0bbe2",
  null
  
)

export default component.exports